import type { ChartComponentSpec } from "../Processing/types";
import type { ControlPanelHandler } from "../widgetContract";
import { isBound, seriesDatePatch } from "./_shared";

export const chartControlPanel: ControlPanelHandler<ChartComponentSpec> = (spec, patch) => {
  for (const ser of spec.series) {
    ser.series_builder_misc = {
      ...ser.series_builder_misc,
      ...(patch.applyDate && !isBound(ser.series_builder_misc, "date", patch) && seriesDatePatch(patch.date)),
      ...(patch.applySubjects && !isBound(ser.series_builder_misc, "subject", patch) && {
        ...patch.subjects,
        inheritPlayers: false,
      }),
    };
  }
};
